// extracted by css-extract-rspack-plugin
export default {"stateReasonLink":"ClosedEvent-module__stateReasonLink__XK4aG04","closerLink":"ClosedEvent-module__closerLink__qs2Umo2"};